import React, { useState, useEffect } from "react";
import CallAPI from "../../../../adminpanel/components/commonComponents/AxiosHelper";
import DisplayFolder from "./DisplayFolder";
import { formatBytes } from "../../commonComponents/CommonHelper"

function FolderPreview({ folderData, authData, countFolder }) {
   
    const [previewData, setPreviewData] = useState(null)

    useEffect(() => {

        let params = { "siteId": authData.siteId, "tableName": folderData.targetTableName, "connectionId": folderData.connectionId };

        CallAPI('get', '/app/get_pulled_file_list', null, params, 0, function (response) {
            if (response.status === true) {
                setPreviewData(response.information);
            } else {
                setPreviewData(null);
            }
        }, authData)

    }, [folderData])

    let columnData = [
        { "virtualName": "File Name", "rawField": "fileName", type: "status", "statusField": "data_summary" },
        { "virtualName": "Sent Date", "rawField": "date", "displayType": "date" }
    ];

    let information = folderData.information ? JSON.parse(folderData.information) : null;

    let tempInformation = {};
    information && Object.keys(information).map(el => {
        if (el === 'fileSize') {
            let sizeInfo = formatBytes(information[el]);
            tempInformation['fileSize'] = `Size: ${sizeInfo}`;
        } else if (el === 'fileCount') {
            tempInformation['fileCount'] = `No. of files: ${information[el]}`;
        }
    })

    let displayData = {
        icon: "fa-file-alt",
        title: folderData && folderData.virtualTableName ? folderData.virtualTableName : `${countFolder} Items`,
        tableData: previewData ? previewData.fileInfo : null,
        columnData: columnData,
        tableHeader: "Data Files",
        information: information ? {
            ...tempInformation,
            rowCount: `Row Count: ${folderData.rowCount}`,
            clientTableName: folderData.clientTableName ? `Client Table Name: ${folderData.clientDBName}.${folderData.clientTableName}` : null
        } : null
    }

    return <DisplayFolder displayData={displayData} />
}

export default FolderPreview;